import { risapi, getAxiosConfig } from './risapi';

export const updateWalletTransaction = async (id, data, callback) => {
    try {
        const response = await risapi.put(`/api/wallet-transactions/${id}`, data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error.response.data); // Return validation errors
    }
};

export const deleteWalletTransaction = async (id, callback) => {
    try {
        await risapi.delete(`/api/wallet-transactions/${id}`, getAxiosConfig());
        callback({ success: true });
    } catch (error) {
        callback(error);
    }
};